import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard_r = () => {
  let xURL = "";
  // let xlocation = window.location.hostname;

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar1, _dataBar1] = useState();
  const [dataBar2, _dataBar2] = useState();
  const [dataBar3, _dataBar3] = useState();
  const [dataBar4, _dataBar4] = useState();
  const [dataBar5, _dataBar5] = useState();

  useEffect(() => {
    Find_barData("bar1");
    Find_barData("bar2");
    Find_barData("bar3");
    Find_barData("bar4");
    Find_barData("bar5");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db3_R", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            if (order == "bar1") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            } else if (order == "bar2") {
              Tb1.push({
                name: i.name,
                q1: i.q1,
                q2: i.q2,
                q3: i.q3,
                q4: i.q4,
                qn_a: i.qn_a
              });
            } else if (order == "bar3") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            } else if (order == "bar4") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            } else if (order == "bar5") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar1") {
          _dataBar1(Tb1);
        } else if (order == "bar2") {
          _dataBar2(Tb1);
        } else if (order == "bar3") {
          _dataBar3(Tb1);
        } else if (order == "bar4") {
          _dataBar4(Tb1);
        } else if (order == "bar5") {
          _dataBar5(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          Research Excellence & High-Impact Study
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนผลงานตีพิมพ์ใน SCOPUS"
          >
            <Barchart dataBar={dataBar1} order={"R1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนผลงานตีพิมพ์ใน SCOPUS (เรื่อง) ตาม Quartile"
          >
            <Barchart dataBar={dataBar2} order={"R2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="[KR1] ร้อยละของผลงานตีพิมพ์ที่เป็น BEEN Research"
          >
            <Barchart dataBar={dataBar3} order={"R3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="[KR3] ร้อยละของผลงานตีพิมพ์ที่อยู่ใน Q1 (SCOPUS)"
          >
            <Barchart dataBar={dataBar4} order={"R4"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="[KR4] ผลงานวิจัยเชิงพาณิชย์ / ต้นแบบ (ผลงานต่อปี)"
          >
            <Barchart dataBar={dataBar5} order={"R5"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard_r;
